export default "__VITE_ASSET__SPWi5pgU__"